import React from 'react';

import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { formatPrice } from '../../../../utils/promo-presentation-utils';

import './PromoHeaderMessaging.scss';

export const PromoHeaderMessaging = () => {
  const { freeItemInCart, bogoSelectedProduct } = usePromoCart();
  const { products } = usePromoModel();

  const freeProductInfo = products.get(freeItemInCart?.itemId);
  const selectedItem = freeProductInfo || bogoSelectedProduct;
  const mapPricing = selectedItem?.pricing?.mapAboveOriginalPrice;
  const bogoSavings = (mapPricing == null || freeItemInCart) ? formatPrice(selectedItem?.pricing?.value) : '';

  return (
    <>
      {selectedItem && (
        <div className="promo-header-messaging u__bold">
          <div className="promo-header-messaging--success">Success!</div>
          <div className="promo-header-messaging--qualified">
            You Have Qualified for a <span className={!bogoSavings ? 'u__text--success' : null}>Free Item</span>
            {bogoSavings && <> and <span className="u__text--success">Save {bogoSavings}</span></>}
          </div>
        </div>
      )}
    </>
  );
};

PromoHeaderMessaging.displayName = 'PromoHeaderMessaging';
